<template>
  <div>
    <div class="d-flex">
      <v-spacer></v-spacer>
      <v-btn
        v-if="!isFilterOpen"
        color="primary"
        depressed
        @click="isFilterOpen = true"
        class="mt-4 mr-4"
      >
        <v-icon>mdi-filter-outline</v-icon>
        篩選器
      </v-btn>
    </div>
    <v-expand-transition>
      <v-card v-if="isFilterOpen">
        <v-card-title>
          篩選器
          <v-divider vertical class="mx-5"></v-divider>
          <v-spacer></v-spacer>
          <v-divider vertical class="mx-5"></v-divider>
          <v-icon
            @click="
              $emit('close');
              isFilterOpen = false;
            "
          >
            mdi-arrow-collapse
          </v-icon>
        </v-card-title>
        <v-card-text>
          <v-form ref="FilterForm">
            <v-row>
              <v-col
                v-for="item in filterOptions"
                :key="`filter${item.label}`"
                cols="auto"
              >
                <v-select
                  v-if="item.type === 'select'"
                  v-model="item.value"
                  v-bind="{
                    ...commonAttrs,
                    ...item
                  }"
                ></v-select>
                <c-autocomplete
                  v-if="item.type === 'autocomplete'"
                  v-model="item.value"
                  v-bind="{
                    ...commonAttrs,
                    ...item
                  }"
                ></c-autocomplete>
                <v-text-field
                  v-if="item.type === 'text'"
                  v-model="item.value"
                  v-bind="{
                    ...commonAttrs,
                    ...item
                  }"
                ></v-text-field>
                <c-date-picker
                  v-if="item.type === 'timeSet'"
                  v-model="item.value"
                  v-bind="{
                    ...commonAttrs,
                    ...item
                  }"
                ></c-date-picker>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4">
          <v-btn color="primary" depressed @click="doSearch" :loading="loading">
            搜尋
          </v-btn>
          <v-btn depressed @click="doClean">清除搜尋內容</v-btn>
        </v-card-actions>
      </v-card>
    </v-expand-transition>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    loading: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default: () => []
    }
  },

  data() {
    return {
      isFilterOpen: false,
      commonAttrs: {
        clearable: true,
        outlined: true,
        dense: true,
        hideDetails: true
      },
      filterOptions: [...this.options]
    };
  },

  computed: {
    parseFilter() {
      const output = {};
      this.filterOptions.forEach(({ name, value }) => {
        if (value !== null) {
          if (/./g.test(name)) {
            name.split('.').reduce((p, c, i, arr) => {
              !p[c] && (p[c] = {});
              if (i + 1 === arr.length) p[c] = value;
              return p[c];
            }, output);
          } else {
            output[name] = value;
          }
        }
      });

      return output;
    }
  },

  mounted() {
    if (Object.entries(this.$route.query).length) {
      this.isFilterOpen = true;
      this.filterOptions.forEach((el) => {
        if (this.$route.query[el.query]) {
          this.$set(el, 'value', this.$route.query[el.query]);
        }
      });
      setTimeout(() => {
        this.doSearch();
      });
    }
  },

  methods: {
    cleanQuery() {
      if (Object.entries(this.$route.query).length) {
        this.$router.replace({ path: this.$route.path, query: null });
      }
    },
    doSearch() {
      this.$emit('input', this.parseFilter);
      this.cleanQuery();

      this.$nextTick(() => {
        this.$emit('search');
      });
    },
    doClean() {
      this.$refs.FilterForm.reset();

      this.$nextTick(() => {
        this.doSearch();
      });
    }
  }
};
</script>

<style lang="scss" scoped>
//
</style>